import { render, staticRenderFns } from "./ProgramsList.vue?vue&type=template&id=53c2b651&scoped=true&"
import script from "./ProgramsList.vue?vue&type=script&lang=js&"
export * from "./ProgramsList.vue?vue&type=script&lang=js&"
import style0 from "./ProgramsList.vue?vue&type=style&index=0&id=53c2b651&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c2b651",
  null
  
)

export default component.exports